/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers/index'
import { Route as AppCustomersIdRouteImport } from './routes/_app/customers/$id'
import { Route as AppHelpIndexRouteImport } from './routes/_app/help/index'
import { Route as AppHelpChapterRouteImport } from './routes/_app/help/$chapter'
import { Route as AppInvoicesIndexRouteImport } from './routes/_app/invoices/index'
import { Route as AppInvoicesIdRouteImport } from './routes/_app/invoices/$id'
import { Route as AppInvoicesNewRouteImport } from './routes/_app/invoices/new'
import { Route as AppOrdersIndexRouteImport } from './routes/_app/orders/index'
import { Route as AppOrdersIdRouteImport } from './routes/_app/orders/$id'
import { Route as AppOrdersNewRouteImport } from './routes/_app/orders/new'
import { Route as AppProductsIndexRouteImport } from './routes/_app/products/index'
import { Route as AppProductsIdRouteImport } from './routes/_app/products/$id'
import { Route as AppPurchasingIndexRouteImport } from './routes/_app/purchasing/index'
import { Route as AppPurchasingIdRouteImport } from './routes/_app/purchasing/$id'
import { Route as AppPurchasingNewRouteImport } from './routes/_app/purchasing/new'
import { Route as AppQuotesIndexRouteImport } from './routes/_app/quotes/index'
import { Route as AppQuotesIdRouteImport } from './routes/_app/quotes/$id'
import { Route as AppQuotesNewRouteImport } from './routes/_app/quotes/new'
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports/index'
import { Route as AppSavIndexRouteImport } from './routes/_app/sav/index'
import { Route as AppSavIdRouteImport } from './routes/_app/sav/$id'
import { Route as AppSavNewRouteImport } from './routes/_app/sav/new'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsActivityRouteImport } from './routes/_app/settings/activity'
import { Route as AppSettingsCompanyRouteImport } from './routes/_app/settings/company'
import { Route as AppSettingsDocumentsRouteImport } from './routes/_app/settings/documents'
import { Route as AppSettingsFamiliesRouteImport } from './routes/_app/settings/families'
import { Route as AppSettingsHealthRouteImport } from './routes/_app/settings/health'
import { Route as AppSettingsImportsRouteImport } from './routes/_app/settings/imports'
import { Route as AppSettingsIntegrationsRouteImport } from './routes/_app/settings/integrations'
import { Route as AppSettingsPrintingRouteImport } from './routes/_app/settings/printing'
import { Route as AppSettingsPurchasingRouteImport } from './routes/_app/settings/purchasing'
import { Route as AppSettingsSalesRouteImport } from './routes/_app/settings/sales'
import { Route as AppSettingsSavRouteImport } from './routes/_app/settings/sav'
import { Route as AppSettingsShippingRouteImport } from './routes/_app/settings/shipping'
import { Route as AppSettingsStockRouteImport } from './routes/_app/settings/stock'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'
import { Route as AppShipmentsIndexRouteImport } from './routes/_app/shipments/index'
import { Route as AppShipmentsIdRouteImport } from './routes/_app/shipments/$id'
import { Route as AppShipmentsFreeRouteImport } from './routes/_app/shipments/free'
import { Route as AppShipmentsNewRouteImport } from './routes/_app/shipments/new'
import { Route as AppStockIndexRouteImport } from './routes/_app/stock/index'
import { Route as AppStockValuationRouteImport } from './routes/_app/stock/valuation'
import { Route as AppSuppliersIndexRouteImport } from './routes/_app/suppliers/index'
import { Route as AppSuppliersIdRouteImport } from './routes/_app/suppliers/$id'
import { Route as AppStockCountsIndexRouteImport } from './routes/_app/stock/counts/index'
import { Route as AppStockCountsIdRouteImport } from './routes/_app/stock/counts/$id'
import { Route as AppStockSerialsIdRouteImport } from './routes/_app/stock/serials/$id'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIdRoute = AppCustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpIndexRoute = AppHelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpChapterRoute = AppHelpChapterRouteImport.update({
  id: '/help/$chapter',
  path: '/help/$chapter',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesIndexRoute = AppInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesIdRoute = AppInvoicesIdRouteImport.update({
  id: '/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesNewRoute = AppInvoicesNewRouteImport.update({
  id: '/invoices/new',
  path: '/invoices/new',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIdRoute = AppOrdersIdRouteImport.update({
  id: '/orders/$id',
  path: '/orders/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersNewRoute = AppOrdersNewRouteImport.update({
  id: '/orders/new',
  path: '/orders/new',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsIndexRoute = AppProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsIdRoute = AppProductsIdRouteImport.update({
  id: '/products/$id',
  path: '/products/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingIndexRoute = AppPurchasingIndexRouteImport.update({
  id: '/purchasing/',
  path: '/purchasing/',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingIdRoute = AppPurchasingIdRouteImport.update({
  id: '/purchasing/$id',
  path: '/purchasing/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingNewRoute = AppPurchasingNewRouteImport.update({
  id: '/purchasing/new',
  path: '/purchasing/new',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesIndexRoute = AppQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesIdRoute = AppQuotesIdRouteImport.update({
  id: '/quotes/$id',
  path: '/quotes/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesNewRoute = AppQuotesNewRouteImport.update({
  id: '/quotes/new',
  path: '/quotes/new',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any)
const AppSavIndexRoute = AppSavIndexRouteImport.update({
  id: '/sav/',
  path: '/sav/',
  getParentRoute: () => AppRoute,
} as any)
const AppSavIdRoute = AppSavIdRouteImport.update({
  id: '/sav/$id',
  path: '/sav/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSavNewRoute = AppSavNewRouteImport.update({
  id: '/sav/new',
  path: '/sav/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsActivityRoute = AppSettingsActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsCompanyRoute = AppSettingsCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDocumentsRoute = AppSettingsDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsFamiliesRoute = AppSettingsFamiliesRouteImport.update({
  id: '/families',
  path: '/families',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsHealthRoute = AppSettingsHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsImportsRoute = AppSettingsImportsRouteImport.update({
  id: '/imports',
  path: '/imports',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsIntegrationsRoute = AppSettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsPrintingRoute = AppSettingsPrintingRouteImport.update({
  id: '/printing',
  path: '/printing',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsPurchasingRoute = AppSettingsPurchasingRouteImport.update({
  id: '/purchasing',
  path: '/purchasing',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSalesRoute = AppSettingsSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSavRoute = AppSettingsSavRouteImport.update({
  id: '/sav',
  path: '/sav',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsShippingRoute = AppSettingsShippingRouteImport.update({
  id: '/shipping',
  path: '/shipping',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsStockRoute = AppSettingsStockRouteImport.update({
  id: '/stock',
  path: '/stock',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppShipmentsIndexRoute = AppShipmentsIndexRouteImport.update({
  id: '/shipments/',
  path: '/shipments/',
  getParentRoute: () => AppRoute,
} as any)
const AppShipmentsIdRoute = AppShipmentsIdRouteImport.update({
  id: '/shipments/$id',
  path: '/shipments/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppShipmentsFreeRoute = AppShipmentsFreeRouteImport.update({
  id: '/shipments/free',
  path: '/shipments/free',
  getParentRoute: () => AppRoute,
} as any)
const AppShipmentsNewRoute = AppShipmentsNewRouteImport.update({
  id: '/shipments/new',
  path: '/shipments/new',
  getParentRoute: () => AppRoute,
} as any)
const AppStockIndexRoute = AppStockIndexRouteImport.update({
  id: '/stock/',
  path: '/stock/',
  getParentRoute: () => AppRoute,
} as any)
const AppStockValuationRoute = AppStockValuationRouteImport.update({
  id: '/stock/valuation',
  path: '/stock/valuation',
  getParentRoute: () => AppRoute,
} as any)
const AppSuppliersIndexRoute = AppSuppliersIndexRouteImport.update({
  id: '/suppliers/',
  path: '/suppliers/',
  getParentRoute: () => AppRoute,
} as any)
const AppSuppliersIdRoute = AppSuppliersIdRouteImport.update({
  id: '/suppliers/$id',
  path: '/suppliers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppStockCountsIndexRoute = AppStockCountsIndexRouteImport.update({
  id: '/stock/counts/',
  path: '/stock/counts/',
  getParentRoute: () => AppRoute,
} as any)
const AppStockCountsIdRoute = AppStockCountsIdRouteImport.update({
  id: '/stock/counts/$id',
  path: '/stock/counts/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppStockSerialsIdRoute = AppStockSerialsIdRouteImport.update({
  id: '/stock/serials/$id',
  path: '/stock/serials/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/customers/$id': typeof AppCustomersIdRoute
  '/help/$chapter': typeof AppHelpChapterRoute
  '/invoices/$id': typeof AppInvoicesIdRoute
  '/invoices/new': typeof AppInvoicesNewRoute
  '/orders/$id': typeof AppOrdersIdRoute
  '/orders/new': typeof AppOrdersNewRoute
  '/products/$id': typeof AppProductsIdRoute
  '/purchasing/$id': typeof AppPurchasingIdRoute
  '/purchasing/new': typeof AppPurchasingNewRoute
  '/quotes/$id': typeof AppQuotesIdRoute
  '/quotes/new': typeof AppQuotesNewRoute
  '/sav/$id': typeof AppSavIdRoute
  '/sav/new': typeof AppSavNewRoute
  '/settings/activity': typeof AppSettingsActivityRoute
  '/settings/company': typeof AppSettingsCompanyRoute
  '/settings/documents': typeof AppSettingsDocumentsRoute
  '/settings/families': typeof AppSettingsFamiliesRoute
  '/settings/health': typeof AppSettingsHealthRoute
  '/settings/imports': typeof AppSettingsImportsRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/printing': typeof AppSettingsPrintingRoute
  '/settings/purchasing': typeof AppSettingsPurchasingRoute
  '/settings/sales': typeof AppSettingsSalesRoute
  '/settings/sav': typeof AppSettingsSavRoute
  '/settings/shipping': typeof AppSettingsShippingRoute
  '/settings/stock': typeof AppSettingsStockRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/shipments/$id': typeof AppShipmentsIdRoute
  '/shipments/free': typeof AppShipmentsFreeRoute
  '/shipments/new': typeof AppShipmentsNewRoute
  '/stock/valuation': typeof AppStockValuationRoute
  '/suppliers/$id': typeof AppSuppliersIdRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/help/': typeof AppHelpIndexRoute
  '/invoices/': typeof AppInvoicesIndexRoute
  '/orders/': typeof AppOrdersIndexRoute
  '/products/': typeof AppProductsIndexRoute
  '/purchasing/': typeof AppPurchasingIndexRoute
  '/quotes/': typeof AppQuotesIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/sav/': typeof AppSavIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/shipments/': typeof AppShipmentsIndexRoute
  '/stock/': typeof AppStockIndexRoute
  '/suppliers/': typeof AppSuppliersIndexRoute
  '/stock/counts/$id': typeof AppStockCountsIdRoute
  '/stock/serials/$id': typeof AppStockSerialsIdRoute
  '/stock/counts/': typeof AppStockCountsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AppIndexRoute
  '/customers/$id': typeof AppCustomersIdRoute
  '/help/$chapter': typeof AppHelpChapterRoute
  '/invoices/$id': typeof AppInvoicesIdRoute
  '/invoices/new': typeof AppInvoicesNewRoute
  '/orders/$id': typeof AppOrdersIdRoute
  '/orders/new': typeof AppOrdersNewRoute
  '/products/$id': typeof AppProductsIdRoute
  '/purchasing/$id': typeof AppPurchasingIdRoute
  '/purchasing/new': typeof AppPurchasingNewRoute
  '/quotes/$id': typeof AppQuotesIdRoute
  '/quotes/new': typeof AppQuotesNewRoute
  '/sav/$id': typeof AppSavIdRoute
  '/sav/new': typeof AppSavNewRoute
  '/settings/activity': typeof AppSettingsActivityRoute
  '/settings/company': typeof AppSettingsCompanyRoute
  '/settings/documents': typeof AppSettingsDocumentsRoute
  '/settings/families': typeof AppSettingsFamiliesRoute
  '/settings/health': typeof AppSettingsHealthRoute
  '/settings/imports': typeof AppSettingsImportsRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/printing': typeof AppSettingsPrintingRoute
  '/settings/purchasing': typeof AppSettingsPurchasingRoute
  '/settings/sales': typeof AppSettingsSalesRoute
  '/settings/sav': typeof AppSettingsSavRoute
  '/settings/shipping': typeof AppSettingsShippingRoute
  '/settings/stock': typeof AppSettingsStockRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/shipments/$id': typeof AppShipmentsIdRoute
  '/shipments/free': typeof AppShipmentsFreeRoute
  '/shipments/new': typeof AppShipmentsNewRoute
  '/stock/valuation': typeof AppStockValuationRoute
  '/suppliers/$id': typeof AppSuppliersIdRoute
  '/customers': typeof AppCustomersIndexRoute
  '/help': typeof AppHelpIndexRoute
  '/invoices': typeof AppInvoicesIndexRoute
  '/orders': typeof AppOrdersIndexRoute
  '/products': typeof AppProductsIndexRoute
  '/purchasing': typeof AppPurchasingIndexRoute
  '/quotes': typeof AppQuotesIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/sav': typeof AppSavIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/shipments': typeof AppShipmentsIndexRoute
  '/stock': typeof AppStockIndexRoute
  '/suppliers': typeof AppSuppliersIndexRoute
  '/stock/counts/$id': typeof AppStockCountsIdRoute
  '/stock/serials/$id': typeof AppStockSerialsIdRoute
  '/stock/counts': typeof AppStockCountsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/customers/$id': typeof AppCustomersIdRoute
  '/_app/help/$chapter': typeof AppHelpChapterRoute
  '/_app/invoices/$id': typeof AppInvoicesIdRoute
  '/_app/invoices/new': typeof AppInvoicesNewRoute
  '/_app/orders/$id': typeof AppOrdersIdRoute
  '/_app/orders/new': typeof AppOrdersNewRoute
  '/_app/products/$id': typeof AppProductsIdRoute
  '/_app/purchasing/$id': typeof AppPurchasingIdRoute
  '/_app/purchasing/new': typeof AppPurchasingNewRoute
  '/_app/quotes/$id': typeof AppQuotesIdRoute
  '/_app/quotes/new': typeof AppQuotesNewRoute
  '/_app/sav/$id': typeof AppSavIdRoute
  '/_app/sav/new': typeof AppSavNewRoute
  '/_app/settings/activity': typeof AppSettingsActivityRoute
  '/_app/settings/company': typeof AppSettingsCompanyRoute
  '/_app/settings/documents': typeof AppSettingsDocumentsRoute
  '/_app/settings/families': typeof AppSettingsFamiliesRoute
  '/_app/settings/health': typeof AppSettingsHealthRoute
  '/_app/settings/imports': typeof AppSettingsImportsRoute
  '/_app/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/_app/settings/printing': typeof AppSettingsPrintingRoute
  '/_app/settings/purchasing': typeof AppSettingsPurchasingRoute
  '/_app/settings/sales': typeof AppSettingsSalesRoute
  '/_app/settings/sav': typeof AppSettingsSavRoute
  '/_app/settings/shipping': typeof AppSettingsShippingRoute
  '/_app/settings/stock': typeof AppSettingsStockRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/shipments/$id': typeof AppShipmentsIdRoute
  '/_app/shipments/free': typeof AppShipmentsFreeRoute
  '/_app/shipments/new': typeof AppShipmentsNewRoute
  '/_app/stock/valuation': typeof AppStockValuationRoute
  '/_app/suppliers/$id': typeof AppSuppliersIdRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/help/': typeof AppHelpIndexRoute
  '/_app/invoices/': typeof AppInvoicesIndexRoute
  '/_app/orders/': typeof AppOrdersIndexRoute
  '/_app/products/': typeof AppProductsIndexRoute
  '/_app/purchasing/': typeof AppPurchasingIndexRoute
  '/_app/quotes/': typeof AppQuotesIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/sav/': typeof AppSavIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/shipments/': typeof AppShipmentsIndexRoute
  '/_app/stock/': typeof AppStockIndexRoute
  '/_app/suppliers/': typeof AppSuppliersIndexRoute
  '/_app/stock/counts/$id': typeof AppStockCountsIdRoute
  '/_app/stock/serials/$id': typeof AppStockSerialsIdRoute
  '/_app/stock/counts/': typeof AppStockCountsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/settings'
    | '/customers/$id'
    | '/help/$chapter'
    | '/invoices/$id'
    | '/invoices/new'
    | '/orders/$id'
    | '/orders/new'
    | '/products/$id'
    | '/purchasing/$id'
    | '/purchasing/new'
    | '/quotes/$id'
    | '/quotes/new'
    | '/sav/$id'
    | '/sav/new'
    | '/settings/activity'
    | '/settings/company'
    | '/settings/documents'
    | '/settings/families'
    | '/settings/health'
    | '/settings/imports'
    | '/settings/integrations'
    | '/settings/printing'
    | '/settings/purchasing'
    | '/settings/sales'
    | '/settings/sav'
    | '/settings/shipping'
    | '/settings/stock'
    | '/settings/users'
    | '/shipments/$id'
    | '/shipments/free'
    | '/shipments/new'
    | '/stock/valuation'
    | '/suppliers/$id'
    | '/customers/'
    | '/help/'
    | '/invoices/'
    | '/orders/'
    | '/products/'
    | '/purchasing/'
    | '/quotes/'
    | '/reports/'
    | '/sav/'
    | '/settings/'
    | '/shipments/'
    | '/stock/'
    | '/suppliers/'
    | '/stock/counts/$id'
    | '/stock/serials/$id'
    | '/stock/counts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/customers/$id'
    | '/help/$chapter'
    | '/invoices/$id'
    | '/invoices/new'
    | '/orders/$id'
    | '/orders/new'
    | '/products/$id'
    | '/purchasing/$id'
    | '/purchasing/new'
    | '/quotes/$id'
    | '/quotes/new'
    | '/sav/$id'
    | '/sav/new'
    | '/settings/activity'
    | '/settings/company'
    | '/settings/documents'
    | '/settings/families'
    | '/settings/health'
    | '/settings/imports'
    | '/settings/integrations'
    | '/settings/printing'
    | '/settings/purchasing'
    | '/settings/sales'
    | '/settings/sav'
    | '/settings/shipping'
    | '/settings/stock'
    | '/settings/users'
    | '/shipments/$id'
    | '/shipments/free'
    | '/shipments/new'
    | '/stock/valuation'
    | '/suppliers/$id'
    | '/customers'
    | '/help'
    | '/invoices'
    | '/orders'
    | '/products'
    | '/purchasing'
    | '/quotes'
    | '/reports'
    | '/sav'
    | '/settings'
    | '/shipments'
    | '/stock'
    | '/suppliers'
    | '/stock/counts/$id'
    | '/stock/serials/$id'
    | '/stock/counts'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/settings'
    | '/_app/'
    | '/_app/customers/$id'
    | '/_app/help/$chapter'
    | '/_app/invoices/$id'
    | '/_app/invoices/new'
    | '/_app/orders/$id'
    | '/_app/orders/new'
    | '/_app/products/$id'
    | '/_app/purchasing/$id'
    | '/_app/purchasing/new'
    | '/_app/quotes/$id'
    | '/_app/quotes/new'
    | '/_app/sav/$id'
    | '/_app/sav/new'
    | '/_app/settings/activity'
    | '/_app/settings/company'
    | '/_app/settings/documents'
    | '/_app/settings/families'
    | '/_app/settings/health'
    | '/_app/settings/imports'
    | '/_app/settings/integrations'
    | '/_app/settings/printing'
    | '/_app/settings/purchasing'
    | '/_app/settings/sales'
    | '/_app/settings/sav'
    | '/_app/settings/shipping'
    | '/_app/settings/stock'
    | '/_app/settings/users'
    | '/_app/shipments/$id'
    | '/_app/shipments/free'
    | '/_app/shipments/new'
    | '/_app/stock/valuation'
    | '/_app/suppliers/$id'
    | '/_app/customers/'
    | '/_app/help/'
    | '/_app/invoices/'
    | '/_app/orders/'
    | '/_app/products/'
    | '/_app/purchasing/'
    | '/_app/quotes/'
    | '/_app/reports/'
    | '/_app/sav/'
    | '/_app/settings/'
    | '/_app/shipments/'
    | '/_app/stock/'
    | '/_app/suppliers/'
    | '/_app/stock/counts/$id'
    | '/_app/stock/serials/$id'
    | '/_app/stock/counts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$id': {
      id: '/_app/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof AppCustomersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/': {
      id: '/_app/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof AppHelpIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/$chapter': {
      id: '/_app/help/$chapter'
      path: '/help/$chapter'
      fullPath: '/help/$chapter'
      preLoaderRoute: typeof AppHelpChapterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/': {
      id: '/_app/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AppInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/$id': {
      id: '/_app/invoices/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof AppInvoicesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/new': {
      id: '/_app/invoices/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AppInvoicesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/': {
      id: '/_app/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/$id': {
      id: '/_app/orders/$id'
      path: '/orders/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof AppOrdersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/new': {
      id: '/_app/orders/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof AppOrdersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/': {
      id: '/_app/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AppProductsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/$id': {
      id: '/_app/products/$id'
      path: '/products/$id'
      fullPath: '/products/$id'
      preLoaderRoute: typeof AppProductsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/': {
      id: '/_app/purchasing/'
      path: '/purchasing'
      fullPath: '/purchasing/'
      preLoaderRoute: typeof AppPurchasingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/$id': {
      id: '/_app/purchasing/$id'
      path: '/purchasing/$id'
      fullPath: '/purchasing/$id'
      preLoaderRoute: typeof AppPurchasingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/new': {
      id: '/_app/purchasing/new'
      path: '/purchasing/new'
      fullPath: '/purchasing/new'
      preLoaderRoute: typeof AppPurchasingNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/': {
      id: '/_app/quotes/'
      path: '/quotes'
      fullPath: '/quotes/'
      preLoaderRoute: typeof AppQuotesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/$id': {
      id: '/_app/quotes/$id'
      path: '/quotes/$id'
      fullPath: '/quotes/$id'
      preLoaderRoute: typeof AppQuotesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/new': {
      id: '/_app/quotes/new'
      path: '/quotes/new'
      fullPath: '/quotes/new'
      preLoaderRoute: typeof AppQuotesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sav/': {
      id: '/_app/sav/'
      path: '/sav'
      fullPath: '/sav/'
      preLoaderRoute: typeof AppSavIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sav/$id': {
      id: '/_app/sav/$id'
      path: '/sav/$id'
      fullPath: '/sav/$id'
      preLoaderRoute: typeof AppSavIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sav/new': {
      id: '/_app/sav/new'
      path: '/sav/new'
      fullPath: '/sav/new'
      preLoaderRoute: typeof AppSavNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/activity': {
      id: '/_app/settings/activity'
      path: '/activity'
      fullPath: '/settings/activity'
      preLoaderRoute: typeof AppSettingsActivityRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/company': {
      id: '/_app/settings/company'
      path: '/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof AppSettingsCompanyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/documents': {
      id: '/_app/settings/documents'
      path: '/documents'
      fullPath: '/settings/documents'
      preLoaderRoute: typeof AppSettingsDocumentsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/families': {
      id: '/_app/settings/families'
      path: '/families'
      fullPath: '/settings/families'
      preLoaderRoute: typeof AppSettingsFamiliesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/health': {
      id: '/_app/settings/health'
      path: '/health'
      fullPath: '/settings/health'
      preLoaderRoute: typeof AppSettingsHealthRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/imports': {
      id: '/_app/settings/imports'
      path: '/imports'
      fullPath: '/settings/imports'
      preLoaderRoute: typeof AppSettingsImportsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/integrations': {
      id: '/_app/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/printing': {
      id: '/_app/settings/printing'
      path: '/printing'
      fullPath: '/settings/printing'
      preLoaderRoute: typeof AppSettingsPrintingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/purchasing': {
      id: '/_app/settings/purchasing'
      path: '/purchasing'
      fullPath: '/settings/purchasing'
      preLoaderRoute: typeof AppSettingsPurchasingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/sales': {
      id: '/_app/settings/sales'
      path: '/sales'
      fullPath: '/settings/sales'
      preLoaderRoute: typeof AppSettingsSalesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/sav': {
      id: '/_app/settings/sav'
      path: '/sav'
      fullPath: '/settings/sav'
      preLoaderRoute: typeof AppSettingsSavRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/shipping': {
      id: '/_app/settings/shipping'
      path: '/shipping'
      fullPath: '/settings/shipping'
      preLoaderRoute: typeof AppSettingsShippingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/stock': {
      id: '/_app/settings/stock'
      path: '/stock'
      fullPath: '/settings/stock'
      preLoaderRoute: typeof AppSettingsStockRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/shipments/': {
      id: '/_app/shipments/'
      path: '/shipments'
      fullPath: '/shipments/'
      preLoaderRoute: typeof AppShipmentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shipments/$id': {
      id: '/_app/shipments/$id'
      path: '/shipments/$id'
      fullPath: '/shipments/$id'
      preLoaderRoute: typeof AppShipmentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shipments/free': {
      id: '/_app/shipments/free'
      path: '/shipments/free'
      fullPath: '/shipments/free'
      preLoaderRoute: typeof AppShipmentsFreeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shipments/new': {
      id: '/_app/shipments/new'
      path: '/shipments/new'
      fullPath: '/shipments/new'
      preLoaderRoute: typeof AppShipmentsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/': {
      id: '/_app/stock/'
      path: '/stock'
      fullPath: '/stock/'
      preLoaderRoute: typeof AppStockIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/valuation': {
      id: '/_app/stock/valuation'
      path: '/stock/valuation'
      fullPath: '/stock/valuation'
      preLoaderRoute: typeof AppStockValuationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suppliers/': {
      id: '/_app/suppliers/'
      path: '/suppliers'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof AppSuppliersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suppliers/$id': {
      id: '/_app/suppliers/$id'
      path: '/suppliers/$id'
      fullPath: '/suppliers/$id'
      preLoaderRoute: typeof AppSuppliersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/counts/': {
      id: '/_app/stock/counts/'
      path: '/stock/counts'
      fullPath: '/stock/counts/'
      preLoaderRoute: typeof AppStockCountsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/counts/$id': {
      id: '/_app/stock/counts/$id'
      path: '/stock/counts/$id'
      fullPath: '/stock/counts/$id'
      preLoaderRoute: typeof AppStockCountsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/serials/$id': {
      id: '/_app/stock/serials/$id'
      path: '/stock/serials/$id'
      fullPath: '/stock/serials/$id'
      preLoaderRoute: typeof AppStockSerialsIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsActivityRoute: typeof AppSettingsActivityRoute
  AppSettingsCompanyRoute: typeof AppSettingsCompanyRoute
  AppSettingsDocumentsRoute: typeof AppSettingsDocumentsRoute
  AppSettingsFamiliesRoute: typeof AppSettingsFamiliesRoute
  AppSettingsHealthRoute: typeof AppSettingsHealthRoute
  AppSettingsImportsRoute: typeof AppSettingsImportsRoute
  AppSettingsIntegrationsRoute: typeof AppSettingsIntegrationsRoute
  AppSettingsPrintingRoute: typeof AppSettingsPrintingRoute
  AppSettingsPurchasingRoute: typeof AppSettingsPurchasingRoute
  AppSettingsSalesRoute: typeof AppSettingsSalesRoute
  AppSettingsSavRoute: typeof AppSettingsSavRoute
  AppSettingsShippingRoute: typeof AppSettingsShippingRoute
  AppSettingsStockRoute: typeof AppSettingsStockRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsActivityRoute: AppSettingsActivityRoute,
  AppSettingsCompanyRoute: AppSettingsCompanyRoute,
  AppSettingsDocumentsRoute: AppSettingsDocumentsRoute,
  AppSettingsFamiliesRoute: AppSettingsFamiliesRoute,
  AppSettingsHealthRoute: AppSettingsHealthRoute,
  AppSettingsImportsRoute: AppSettingsImportsRoute,
  AppSettingsIntegrationsRoute: AppSettingsIntegrationsRoute,
  AppSettingsPrintingRoute: AppSettingsPrintingRoute,
  AppSettingsPurchasingRoute: AppSettingsPurchasingRoute,
  AppSettingsSalesRoute: AppSettingsSalesRoute,
  AppSettingsSavRoute: AppSettingsSavRoute,
  AppSettingsShippingRoute: AppSettingsShippingRoute,
  AppSettingsStockRoute: AppSettingsStockRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppCustomersIdRoute: typeof AppCustomersIdRoute
  AppHelpChapterRoute: typeof AppHelpChapterRoute
  AppInvoicesIdRoute: typeof AppInvoicesIdRoute
  AppInvoicesNewRoute: typeof AppInvoicesNewRoute
  AppOrdersIdRoute: typeof AppOrdersIdRoute
  AppOrdersNewRoute: typeof AppOrdersNewRoute
  AppProductsIdRoute: typeof AppProductsIdRoute
  AppPurchasingIdRoute: typeof AppPurchasingIdRoute
  AppPurchasingNewRoute: typeof AppPurchasingNewRoute
  AppQuotesIdRoute: typeof AppQuotesIdRoute
  AppQuotesNewRoute: typeof AppQuotesNewRoute
  AppSavIdRoute: typeof AppSavIdRoute
  AppSavNewRoute: typeof AppSavNewRoute
  AppShipmentsIdRoute: typeof AppShipmentsIdRoute
  AppShipmentsFreeRoute: typeof AppShipmentsFreeRoute
  AppShipmentsNewRoute: typeof AppShipmentsNewRoute
  AppStockValuationRoute: typeof AppStockValuationRoute
  AppSuppliersIdRoute: typeof AppSuppliersIdRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppHelpIndexRoute: typeof AppHelpIndexRoute
  AppInvoicesIndexRoute: typeof AppInvoicesIndexRoute
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute
  AppProductsIndexRoute: typeof AppProductsIndexRoute
  AppPurchasingIndexRoute: typeof AppPurchasingIndexRoute
  AppQuotesIndexRoute: typeof AppQuotesIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppSavIndexRoute: typeof AppSavIndexRoute
  AppShipmentsIndexRoute: typeof AppShipmentsIndexRoute
  AppStockIndexRoute: typeof AppStockIndexRoute
  AppSuppliersIndexRoute: typeof AppSuppliersIndexRoute
  AppStockCountsIdRoute: typeof AppStockCountsIdRoute
  AppStockSerialsIdRoute: typeof AppStockSerialsIdRoute
  AppStockCountsIndexRoute: typeof AppStockCountsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppCustomersIdRoute: AppCustomersIdRoute,
  AppHelpChapterRoute: AppHelpChapterRoute,
  AppInvoicesIdRoute: AppInvoicesIdRoute,
  AppInvoicesNewRoute: AppInvoicesNewRoute,
  AppOrdersIdRoute: AppOrdersIdRoute,
  AppOrdersNewRoute: AppOrdersNewRoute,
  AppProductsIdRoute: AppProductsIdRoute,
  AppPurchasingIdRoute: AppPurchasingIdRoute,
  AppPurchasingNewRoute: AppPurchasingNewRoute,
  AppQuotesIdRoute: AppQuotesIdRoute,
  AppQuotesNewRoute: AppQuotesNewRoute,
  AppSavIdRoute: AppSavIdRoute,
  AppSavNewRoute: AppSavNewRoute,
  AppShipmentsIdRoute: AppShipmentsIdRoute,
  AppShipmentsFreeRoute: AppShipmentsFreeRoute,
  AppShipmentsNewRoute: AppShipmentsNewRoute,
  AppStockValuationRoute: AppStockValuationRoute,
  AppSuppliersIdRoute: AppSuppliersIdRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppHelpIndexRoute: AppHelpIndexRoute,
  AppInvoicesIndexRoute: AppInvoicesIndexRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
  AppProductsIndexRoute: AppProductsIndexRoute,
  AppPurchasingIndexRoute: AppPurchasingIndexRoute,
  AppQuotesIndexRoute: AppQuotesIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppSavIndexRoute: AppSavIndexRoute,
  AppShipmentsIndexRoute: AppShipmentsIndexRoute,
  AppStockIndexRoute: AppStockIndexRoute,
  AppSuppliersIndexRoute: AppSuppliersIndexRoute,
  AppStockCountsIdRoute: AppStockCountsIdRoute,
  AppStockSerialsIdRoute: AppStockSerialsIdRoute,
  AppStockCountsIndexRoute: AppStockCountsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
